import {
  Box,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import React from "react";
import CloseIcon from "@material-ui/icons/Close";
import { convertToLocaleDateTime } from "../functionalComponents/FormatDateTimeToLocale";
import moment from "moment";

// const row = {
//   scheduleLineDetails: {
//     stabilityReqmtSamplingQty: null,
//     scheduleAgreementNumber: "4500022548",
//     stabilityReqmtSampling: null,
//     committedQuantity: 20000,
//     EUImportationSamplingReqd: null,
//     storageLocation: "",
//     artworkRequired: null,
//     uom: "BOX",
//     sponsorProposedQuantity: null,
//     scheduleLineItemNumber: 10,
//     requestedQuantity: 20000,
//     brandOwnerMosymphonyID: 2,
//     committedDeliveryDate: "2024-10-03T00:00",
//     requestedDate: "2024-10-03T00:00",
//     deliveryDate: "2024-10-03T00:00",
//     sponsorProposedDate: null,
//     cmoProposedQuantity: null,
//     brand: null,
//     productType: null,
//     cmoProposedDate: null,
//     scheduleLineStatusText: "Confirmed",
//     aboRisk: null,
//     scheduleLineStatusID: 25,
//     fgMaterialCode: "50065944",
//     poOrderAcknowledgementNumber: null,
//     schrockenSLID: 25681,
//     market: null,
//     EUImportationSamplingQty: null,
//     vendorPlant: "CMO1",
//     cmoSalesOrderNumber: null,
//     fgMaterialName: "TRANSPACER G",
//     vendorMosymphonyID: 3,
//     schrockenSAID: 25535,
//     targetQuantity: 20000,
//     vendorName: "Resilient Generics Limited",
//     sponsorName: "Tree Tops Life Sciences Inc",
//     deliveryAddress: {
//       street_address_1: "Vihari Homes",
//       street_address_2: "Navadurga Colony",
//     },
//     pickupAddress: {
//       street_address_1: "sai nagar, vemualawada, karimnagar",
//       street_address_2: "sai nagar, vemualawada, karimnagar",
//     },
//   },
//   batchDetails: {},
// };

// const poLineAuditsNewData = {
//   poLineAuditTrail: [
//     {
//       lastUpdatedDate: "02/01/2025 18:16:00 (IST)",
//       lastUpdatedBy: "eddie.wyatt@immunocell.com",
//       event: "Date of creation added",
//       eventDescription: "Date of creation added",
//       status: "Confirmed",
//       batchStatus: "N/A",
//       senderLegalName: "N/A",
//       organizationName: "N/A",
//       role: "Planner",
//       userName: "eddie.wyatt@immunocell.com",
//     },
//     {
//       lastUpdatedDate: "02/01/2025 17:30:00 (IST)",
//       lastUpdatedBy: "eddie.wyatt@immunocell.com",
//       event: "RM/PM lot MFG start date changed",
//       eventDescription: "RM/PM lot MFG start date changed",
//       status: "Confirmed",
//       batchStatus: "N/A",
//       senderLegalName: "N/A",
//       organizationName: "N/A",
//       role: "Planner",
//       userName: "eddie.wyatt@immunocell.com",
//     },
//     {
//       lastUpdatedDate: "02/01/2025 14:12:00 (IST)",
//       lastUpdatedBy: "eddie.wyatt@immunocell.com",
//       event: "EU importation sampling requirement",
//       eventDescription: "EU importation sampling requirement",
//       status: "Confirmed",
//       batchStatus: "N/A",
//       senderLegalName: "N/A",
//       organizationName: "N/A",
//       role: "Planner",
//       userName: "eddie.wyatt@immunocell.com",
//     },
//   ],
// };

// const recentChanges = [
//   {
//     dateTime: "02/01/2025 18:10:00 (IST)",
//     event: "Date of provision edited",
//     role: "Planner",
//     username: "eddie.wyatt@immunocell.com",
//   },
//   {
//     dateTime: "02/01/2025 17:30:10 (IST)",
//     event: "rM&PT lot MFG start date changed",
//     role: "Planner",
//     username: "eddie.wyatt@immunocell.com",
//   },
//   {
//     dateTime: "02/01/2025 14:12:00 (IST)",
//     event: "EU importation sampling requirement",
//     role: "Planner",
//     username: "eddie.wyatt@immunocell.com",
//   },
// ];

// const renderPOStatusButton = (statusID, statusText) => {
//   let color;
//   switch (statusID) {
//     case 21: //"Created"
//       color = "#B4B4B4"; // Bright orange for Ongoing
//       break;
//     case 23: //"Under confirmation":
//       color = "#E78A00"; // Green for Completed
//       break;
//     case 22: //"Shared with CMO":
//       color = "#2196F3"; // Grey for Awaiting Start
//       break;
//     case 4: //"Confirmed":
//       color = "#707070"; // Grey for Awaiting Start
//       break;
//     case 27: //"Approved":
//       color = "#329429"; // Grey for Awaiting Start
//       break;
//     case 24: //"Rejected By CMO":
//       color = "#FF0000";
//     case 26: //"Rejected By CMO":
//       color = "#EC6535";
//       break;
//     default:
//       color = "#1E1E1E";
//   }
//   return (
//     <Typography
//       variant="body1"
//       style={{
//         textAlign: "center",
//         padding: "0.25rem",
//         borderRadius: "0.45rem",
//         fontSize: "0.875rem",
//         color: "white",
//         backgroundColor: color,
//         border: `2px solid ${color}`,
//         whiteSpace: "nowrap",
//       }}
//     >
//       {statusText}
//     </Typography>
//   );
// };

const renderPOStatusButton = (statusID, statusText) => {
  let color;
  switch (statusID) {
    case 21: //"Created"
      color = "#B4B4B4";
      break;
    case 23: //"Under confirmation":
      color = "#E78A00";
      break;
    case 22: //"Shared with CMO":
      color = "#2196F3";
      break;
    case 25: //"Confirmed":
      color = "#329429";
      break;
    case 29: //"Under Revision":
      color = "#329429";
      break;
    case 31: //"Revised":
      color = "#329429";
      break;
    case 30: //"Delivery Complete":
      color = "#707070";
      break;
    case 27: //"Approved":
      color = "#329429"; // Grey for Awaiting Start
      break;
    case 24: //"Rejected By CMO":
      color = "#FF0000";
      break;
    default:
      color = "#1E1E1E";
  }
  return (
    <Typography
      variant="body1"
      style={{
        textAlign: "center",
        padding: "0.25rem",
        borderRadius: "0.45rem",
        fontSize: "0.875rem",
        color: "white",
        backgroundColor: color,
        border: `2px solid ${color}`,
        whiteSpace: "nowrap",
      }}
    >
      {statusText}
    </Typography>
  );
};

const ViewThreeRecentChanges = ({
  openAction,
  setOpenAction,
  rowInfo,
  poLineAuditsNewData,
  poLineAuditsNewDataLoading,
}) => {
  return (
    <div>
      <Dialog
        open={openAction}
        onClose={() => setOpenAction(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            height: "72vh",  // Changed from fixed height to auto to prevent scrollbar
            maxHeight: "90vh", // Added maxHeight instead of fixed height
            width: "60%",
            maxWidth: "none",
          },
        }}
      >
        <DialogTitle>
          <Typography
            align="center"
            style={{ fontWeight: "bold", marginTop: "1rem" }}
            variant="h5"
          >
            View three most recent changes
          </Typography>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            mb={2}
          >
            <Grid item xs={2}>
              <Typography
                variant="body2"
                style={{
                  display: "flex",
                  alignItems: "center",
                  position: "absolute",
                  top: "12px",
                  right: "10px",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
                onClick={() => setOpenAction(false)}
              >
                Cancel{" "}
                <CloseIcon style={{ fontSize: "35px", color: "#FF0000" }} />
              </Typography>
            </Grid>
          </Box>
        </DialogTitle>
        <DialogContent style={{ overflowY: 'hidden' }}> {/* Prevent scrollbar */}
          <TableContainer
            component={Paper}
            style={{ backgroundColor: "#f2f8fb" }}
          >
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell style={{fontWeight: 'bold' }}>PO Number</TableCell>
                  <TableCell style={{fontWeight: 'bold' }}>Product Code / Description</TableCell> {/* Updated */}
                  <TableCell style={{fontWeight: 'bold' }}>CMO</TableCell>
                  <TableCell style={{ textAlign: "center", fontWeight: 'bold' }}>
                    PO Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {rowInfo?.scheduleLineDetails && (
                  <TableRow>
                    <TableCell>
                      {rowInfo?.scheduleLineDetails?.scheduleAgreementNumber ||
                        "N/A"}
                    </TableCell>
                    <TableCell>
                      {rowInfo.scheduleLineDetails.fgMaterialCode || "N/A"} /{" "}
                      <br />
                      {rowInfo.scheduleLineDetails.fgMaterialName || "N/A"}
                    </TableCell>
                    <TableCell>
                      {rowInfo.scheduleLineDetails.vendorName || "N/A"}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      {renderPOStatusButton(
                        rowInfo?.scheduleLineDetails?.scheduleLineStatusID,
                        rowInfo.scheduleLineDetails.scheduleLineStatusText
                      )}
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Table style={{ marginTop: "1.5rem" }}>
            <TableHead
              style={{
                backgroundColor: "#FFE4C2",
                border: "1px solid #ffab91",
              }}
            >
              <TableRow>
                <TableCell></TableCell>
                <TableCell style={{ whiteSpace: "nowrap", fontWeight: 'bold' }}>
                  Date and time
                </TableCell>
                <TableCell style={{fontWeight: 'bold' }}>Event</TableCell>
                <TableCell style={{fontWeight: 'bold' }}>Role</TableCell>
                <TableCell style={{fontWeight: 'bold' }}>Username</TableCell>
              </TableRow>
            </TableHead>
            {poLineAuditsNewDataLoading === true ? (
              <TableRow style={{ height: 150 }}>
                <TableCell colSpan={12}>
                  <div style={{ textAlign: "center" }}>
                    <CircularProgress color="primary" thickness={7} />
                  </div>
                </TableCell>
              </TableRow>
            ) : poLineAuditsNewData?.data?.poLineAuditTrail.length > 0 ? (
              <TableBody>
                {poLineAuditsNewData?.data?.poLineAuditTrail.map(
                  (row, index) => (
                    <TableRow key={index}>
                      <TableCell>
                        <Box
                          display="flex"
                          alignItems="center"
                          position="relative"
                        >
                          <Box
                            style={{
                              width: 12,
                              height: 12,
                              backgroundColor: "orangeRed",
                              borderRadius: "50%",
                              position: "relative",
                              zIndex: 2,
                            }}
                          />
                          {index !==
                            poLineAuditsNewData?.data?.poLineAuditTrail
                              .length && (
                              <Box
                                style={{
                                  position: "absolute",
                                  width: 1.5,
                                  height: "4.7rem",
                                  backgroundColor: "gray",
                                  left: 5,
                                  top: -19,
                                }}
                              />
                            )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {row?.lastUpdatedDate ? (
                          <>
                            {moment(
                              convertToLocaleDateTime(row?.lastUpdatedDate)
                            ).format("DD-MMM-YYYY").toUpperCase()}
                            <br />
                            {moment(
                              convertToLocaleDateTime(row?.lastUpdatedDate)
                            ).format("HH:mm:ss")}
                          </>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell>{row?.event || ""}</TableCell>
                      <TableCell>{row?.role || ""}</TableCell>
                      <TableCell>{row?.lastUpdatedBy || ""}</TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            ) : poLineAuditsNewData?.status === false ? (
              <TableRow
                style={{
                  border: "2px solid rgb(255,0,0)",
                  backgroundColor: "rgb(255,240,240)",
                  textAlign: "center",
                  padding: "0.8rem",
                  fontSize: "0.875rem",
                }}
              >
                <TableCell colSpan={10} align="center">
                  {"Something went wrong. Please contact Schrocken Support."}
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={9} align="center">
                  No records found
                </TableCell>
              </TableRow>
            )}
          </Table>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ViewThreeRecentChanges;
